// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Estilo general para el formulario */
.form-grid {
    display: grid;
    grid-template-columns: repeat(4, minmax(150px, 1fr)); /* Forzar 4 columnas con mínimo 150px */
    gap: 1rem; /* Espaciado entre los campos */
    row-gap: 0.5rem; /* Espaciado entre filas */
    column-gap: 0.5rem; /* Espaciado entre columnas */
}

/* Reducir el margen y el relleno de los campos */
.field {
    margin-bottom: 0.1rem; /* Reducir espacio entre campos */
    text-align: left;
}

/* Estilo para campos de solo lectura */
.readonly-field {
    background-color: #f5f5f5; /* Gris claro */
    color: #6c757d; /* Texto gris oscuro */
    border: 1px solid #ced4da; /* Borde gris */
    cursor: not-allowed; /* Cursor no permitido */
}

/* Ajustar el ancho de los inputs y calendarios */
input[type="text"], .p-inputtext, .p-calendar {
    width: 100%;
    box-sizing: border-box; /* Asegurar que el padding no rompa el diseño */
    text-align: left;
}

/* Ajustar el área de texto */
.p-inputtextarea {
    resize: none; /* Evitar redimensionar */
    width: 100%;
}

/* Ajustar botones en el pie del diálogo */
.p-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem; /* Espaciado entre botones */
}

/* Estilo general para el formulario */
.form-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr); /* Dos columnas */
    gap: 0.5rem; /* Espaciado reducido entre columnas y filas */
}

/* Reducir el margen y el relleno de los campos */
.field {
    margin-bottom: 0; /* Eliminar espacio inferior */
    padding: 0; /* Asegurar que no haya relleno */
}

/* Estilo para campos de solo lectura */
.readonly-field {
    background-color: #f5f5f5; /* Gris claro */
    color: #6c757d; /* Texto gris oscuro */
    border: 1px solid #ced4da; /* Borde gris */
    cursor: not-allowed; /* Cursor no permitido */
}

/* Ajustar el ancho de los inputs y calendarios */
input[type="text"], .p-inputtext, .p-calendar {
    width: 100%;
    box-sizing: border-box; /* Asegurar que el padding no rompa el diseño */
}

/* Ajustar el área de texto */
.p-inputtextarea {
    resize: none; /* Evitar redimensionar */
    width: 100%;
}

/* Ajustar botones en el pie del diálogo */
.p-dialog-footer {
    display: flex;
    justify-content: flex-end;
    gap: 0.5rem; /* Espaciado entre botones */
}

/* Estilo principal del contenedor */
.p-fluid.form-grid {
    display: grid; /* Configura el grid */
    grid-template-columns: repeat(4, 1fr); /* Dos columnas iguales */
    row-gap: 0.5rem; /* Reduce espacio entre las filas */
    column-gap: 0.5rem; /* Reduce espacio entre las columnas */
}

/* Configuración de los campos individuales */
.p-fluid.form-grid .field {
    margin-bottom: 0; /* Eliminar margen inferior */
    display: flex;
    flex-direction: column;
    gap: 0.2rem; /* Espacio mínimo entre etiqueta y campo */
}

/* Estilo para las etiquetas */
.p-fluid.form-grid .field label {
    font-size: 14px; /* Tamaño de fuente compacto */
    margin-bottom: 0; /* Eliminar margen inferior */
    color: #333; /* Color del texto de la etiqueta */
    line-height: 1; /* Reducir espacio vertical en las etiquetas */
}

/* Estilo para los inputs, textarea y calendarios */
.p-fluid.form-grid input,
.p-fluid.form-grid textarea,
.p-fluid.form-grid .p-inputtext,
.p-fluid.form-grid .p-calendar {
    padding: 6px 8px; /* Ajusta el padding interno */
    font-size: 12px; /* Tamaño de fuente */
    border-radius: 4px; /* Bordes redondeados */
    margin: 0; /* Asegura que no tengan margen adicional */
    text-align: left;
}

/* Estilo para campos de solo lectura */
.p-fluid.form-grid .readonly-field {
    background-color: #f5f5f5; /* Fondo gris */
    color: #666; /* Texto en color tenue */
    border: 1px solid #ddd; /* Borde claro */
}

.p-calendar input {
    text-align: left !important; /* Fuerza la alineación a la izquierda */
}

.p-fluid.form-grid .p-calendar .p-inputtext {
    text-align: left; /* Alinea el texto a la izquierda */
}`, "",{"version":3,"sources":["webpack://./src/styles/EditarPedidoModal.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;IACI,aAAa;IACb,oDAAoD,EAAE,uCAAuC;IAC7F,SAAS,EAAE,+BAA+B;IAC1C,eAAe,EAAE,0BAA0B;IAC3C,kBAAkB,EAAE,6BAA6B;AACrD;;AAEA,iDAAiD;AACjD;IACI,qBAAqB,EAAE,iCAAiC;IACxD,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,yBAAyB,EAAE,eAAe;IAC1C,cAAc,EAAE,sBAAsB;IACtC,yBAAyB,EAAE,eAAe;IAC1C,mBAAmB,EAAE,wBAAwB;AACjD;;AAEA,iDAAiD;AACjD;IACI,WAAW;IACX,sBAAsB,EAAE,+CAA+C;IACvE,gBAAgB;AACpB;;AAEA,6BAA6B;AAC7B;IACI,YAAY,EAAE,yBAAyB;IACvC,WAAW;AACf;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW,EAAE,4BAA4B;AAC7C;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,qCAAqC,EAAE,iBAAiB;IACxD,WAAW,EAAE,8CAA8C;AAC/D;;AAEA,iDAAiD;AACjD;IACI,gBAAgB,EAAE,8BAA8B;IAChD,UAAU,EAAE,iCAAiC;AACjD;;AAEA,uCAAuC;AACvC;IACI,yBAAyB,EAAE,eAAe;IAC1C,cAAc,EAAE,sBAAsB;IACtC,yBAAyB,EAAE,eAAe;IAC1C,mBAAmB,EAAE,wBAAwB;AACjD;;AAEA,iDAAiD;AACjD;IACI,WAAW;IACX,sBAAsB,EAAE,+CAA+C;AAC3E;;AAEA,6BAA6B;AAC7B;IACI,YAAY,EAAE,yBAAyB;IACvC,WAAW;AACf;;AAEA,0CAA0C;AAC1C;IACI,aAAa;IACb,yBAAyB;IACzB,WAAW,EAAE,4BAA4B;AAC7C;;AAEA,oCAAoC;AACpC;IACI,aAAa,EAAE,sBAAsB;IACrC,qCAAqC,EAAE,yBAAyB;IAChE,eAAe,EAAE,mCAAmC;IACpD,kBAAkB,EAAE,sCAAsC;AAC9D;;AAEA,6CAA6C;AAC7C;IACI,gBAAgB,EAAE,6BAA6B;IAC/C,aAAa;IACb,sBAAsB;IACtB,WAAW,EAAE,0CAA0C;AAC3D;;AAEA,8BAA8B;AAC9B;IACI,eAAe,EAAE,8BAA8B;IAC/C,gBAAgB,EAAE,6BAA6B;IAC/C,WAAW,EAAE,mCAAmC;IAChD,cAAc,EAAE,8CAA8C;AAClE;;AAEA,mDAAmD;AACnD;;;;IAII,gBAAgB,EAAE,8BAA8B;IAChD,eAAe,EAAE,qBAAqB;IACtC,kBAAkB,EAAE,uBAAuB;IAC3C,SAAS,EAAE,2CAA2C;IACtD,gBAAgB;AACpB;;AAEA,uCAAuC;AACvC;IACI,yBAAyB,EAAE,eAAe;IAC1C,WAAW,EAAE,yBAAyB;IACtC,sBAAsB,EAAE,gBAAgB;AAC5C;;AAEA;IACI,2BAA2B,EAAE,wCAAwC;AACzE;;AAEA;IACI,gBAAgB,EAAE,mCAAmC;AACzD","sourcesContent":["/* Estilo general para el formulario */\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(4, minmax(150px, 1fr)); /* Forzar 4 columnas con mínimo 150px */\n    gap: 1rem; /* Espaciado entre los campos */\n    row-gap: 0.5rem; /* Espaciado entre filas */\n    column-gap: 0.5rem; /* Espaciado entre columnas */\n}\n\n/* Reducir el margen y el relleno de los campos */\n.field {\n    margin-bottom: 0.1rem; /* Reducir espacio entre campos */\n    text-align: left;\n}\n\n/* Estilo para campos de solo lectura */\n.readonly-field {\n    background-color: #f5f5f5; /* Gris claro */\n    color: #6c757d; /* Texto gris oscuro */\n    border: 1px solid #ced4da; /* Borde gris */\n    cursor: not-allowed; /* Cursor no permitido */\n}\n\n/* Ajustar el ancho de los inputs y calendarios */\ninput[type=\"text\"], .p-inputtext, .p-calendar {\n    width: 100%;\n    box-sizing: border-box; /* Asegurar que el padding no rompa el diseño */\n    text-align: left;\n}\n\n/* Ajustar el área de texto */\n.p-inputtextarea {\n    resize: none; /* Evitar redimensionar */\n    width: 100%;\n}\n\n/* Ajustar botones en el pie del diálogo */\n.p-dialog-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem; /* Espaciado entre botones */\n}\n\n/* Estilo general para el formulario */\n.form-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr); /* Dos columnas */\n    gap: 0.5rem; /* Espaciado reducido entre columnas y filas */\n}\n\n/* Reducir el margen y el relleno de los campos */\n.field {\n    margin-bottom: 0; /* Eliminar espacio inferior */\n    padding: 0; /* Asegurar que no haya relleno */\n}\n\n/* Estilo para campos de solo lectura */\n.readonly-field {\n    background-color: #f5f5f5; /* Gris claro */\n    color: #6c757d; /* Texto gris oscuro */\n    border: 1px solid #ced4da; /* Borde gris */\n    cursor: not-allowed; /* Cursor no permitido */\n}\n\n/* Ajustar el ancho de los inputs y calendarios */\ninput[type=\"text\"], .p-inputtext, .p-calendar {\n    width: 100%;\n    box-sizing: border-box; /* Asegurar que el padding no rompa el diseño */\n}\n\n/* Ajustar el área de texto */\n.p-inputtextarea {\n    resize: none; /* Evitar redimensionar */\n    width: 100%;\n}\n\n/* Ajustar botones en el pie del diálogo */\n.p-dialog-footer {\n    display: flex;\n    justify-content: flex-end;\n    gap: 0.5rem; /* Espaciado entre botones */\n}\n\n/* Estilo principal del contenedor */\n.p-fluid.form-grid {\n    display: grid; /* Configura el grid */\n    grid-template-columns: repeat(4, 1fr); /* Dos columnas iguales */\n    row-gap: 0.5rem; /* Reduce espacio entre las filas */\n    column-gap: 0.5rem; /* Reduce espacio entre las columnas */\n}\n\n/* Configuración de los campos individuales */\n.p-fluid.form-grid .field {\n    margin-bottom: 0; /* Eliminar margen inferior */\n    display: flex;\n    flex-direction: column;\n    gap: 0.2rem; /* Espacio mínimo entre etiqueta y campo */\n}\n\n/* Estilo para las etiquetas */\n.p-fluid.form-grid .field label {\n    font-size: 14px; /* Tamaño de fuente compacto */\n    margin-bottom: 0; /* Eliminar margen inferior */\n    color: #333; /* Color del texto de la etiqueta */\n    line-height: 1; /* Reducir espacio vertical en las etiquetas */\n}\n\n/* Estilo para los inputs, textarea y calendarios */\n.p-fluid.form-grid input,\n.p-fluid.form-grid textarea,\n.p-fluid.form-grid .p-inputtext,\n.p-fluid.form-grid .p-calendar {\n    padding: 6px 8px; /* Ajusta el padding interno */\n    font-size: 12px; /* Tamaño de fuente */\n    border-radius: 4px; /* Bordes redondeados */\n    margin: 0; /* Asegura que no tengan margen adicional */\n    text-align: left;\n}\n\n/* Estilo para campos de solo lectura */\n.p-fluid.form-grid .readonly-field {\n    background-color: #f5f5f5; /* Fondo gris */\n    color: #666; /* Texto en color tenue */\n    border: 1px solid #ddd; /* Borde claro */\n}\n\n.p-calendar input {\n    text-align: left !important; /* Fuerza la alineación a la izquierda */\n}\n\n.p-fluid.form-grid .p-calendar .p-inputtext {\n    text-align: left; /* Alinea el texto a la izquierda */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
